<template>
  <div :class="_.keyword">
    <div :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
      <div v-else-if="theme.titleType === 'text'" :class="_.title">
        <div :class="_.primary" :style="{ color: theme.titleFontColor }">
          {{ theme.title }}
        </div>
        <div :class="_.secondary" :style="{ color: theme.subTitleFontColor }">
          {{ theme.subTitle }}
        </div>
      </div>
    </div>
    <div :class="_.bd">
      <div
        v-for="(item, index) in data"
        :key="index"
        v-track="{
          name: '店铺关键词-项目',
          id: `DianJiZiDingYiYeZiYuan`,
          resource: item,
          index: index,
          extra: getTrackExtra(item, index),
        }"
        :class="_.item"
        :style="{
          backgroundColor: theme.tagBackgroundColor,
          color: theme.tagFontColor,
        }"
        @click="$dmbcResourceClick(item)"
      >
        # {{ item.title }}
        <img v-if="item.icon" :src="item.icon" :class="_.badge" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .keyword {
    border-radius: var(--border-radius);
    padding: 12px;
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
      }

      .title {
        display: flex;
        align-items: center;

        .primary {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }

        .secondary {
          margin-left: 6px;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
      }
    }

    .bd {
      display: flex;
      flex-wrap: wrap;

      .item {
        position: relative;
        margin-top: 8px;
        margin-right: 8px;
        height: 28px;
        padding: 0 10px;
        background: #ffe9ea;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ff0e18;

        .badge {
          position: absolute;
          left: calc(100% - 18px);
          top: -7px;
          height: 14px;
          z-index: 1;
        }
      }
    }
  }
</style>
